import { render } from "./EntityList.vue?vue&type=template&id=bcfe81bc&ts=true"
import script from "./EntityList.vue?vue&type=script&lang=ts"
export * from "./EntityList.vue?vue&type=script&lang=ts"

import "./EntityList.vue?vue&type=style&index=0&id=bcfe81bc&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__